// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"BuildingBudgetLoader_spinnerContainer__3SN_W","text":"BuildingBudgetLoader_text__3SA0q"};